import styled from 'styled-components';

export const StyledInline = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['alignItems', 'columnGap', 'justifyContent', 'mt', 'mb'].includes(prop),
})`
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
  column-gap: ${({ columnGap }) => columnGap};
  justify-content: ${({ justifyContent }) => justifyContent};
  margin-top: ${({ mt }) => mt};
  margin-bottom: ${({ mb }) => mb};
`;
